
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppSwitch } from '@/components';
import { AppFileUpload, AppImageHolder, AppAvatarBreadcrumb } from '@/components';
import { useAvatarCategoryEdit } from '@/modules/avatar/category/model/edit';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { AvatarGender } from '@/modules/avatar/gender/model/gender';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.CATEGORY.EDIT,
    components: {
        AppFormRow,
        AppInput,
        AppCard,
        AppButton,
        AppSelect,
        AppSwitch,
        AppFileUpload,
        AppImageHolder,
        AppAvatarBreadcrumb
    },
    setup() {
        const { model, v$, actions } = useAvatarCategoryEdit();

        onMounted(() => {
            actions.fetch();
        });

        return { v$, model, actions, AvatarGender, ROUTE_NAME_AVATAR };
    }
});
